import type {z} from "zod";

import {ListServicesQueryParams} from "@project/sdk/engineering/zod";

export const listServicesSearchSchema = ListServicesQueryParams.extend({
  page: ListServicesQueryParams.shape.page.catch(1).default(1),
  perPage: ListServicesQueryParams.shape.perPage.catch(20).default(20),
  q: ListServicesQueryParams.shape.q.catch(undefined),
  state: ListServicesQueryParams.shape.state.catch("ACTIVE"),
  compositionKind: ListServicesQueryParams.shape.compositionKind.catch(undefined),
  supplyStatus: ListServicesQueryParams.shape.supplyStatus.catch(undefined),
  functionId: ListServicesQueryParams.shape.functionId.catch(undefined),
  billingUnit: ListServicesQueryParams.shape.billingUnit.catch(undefined),
  sortKey: ListServicesQueryParams.shape.sortKey.catch("serviceId"),
  sortDir: ListServicesQueryParams.shape.sortDir.catch("asc").default("asc"),
});

export type ListServicesSearchInput = z.input<typeof listServicesSearchSchema>;
export type ListServicesSearch = z.output<typeof listServicesSearchSchema>;
